import { render, staticRenderFns } from "./MAOrders.vue?vue&type=template&id=45174a6c"
import script from "./MAOrders.vue?vue&type=script&lang=js"
export * from "./MAOrders.vue?vue&type=script&lang=js"
import style0 from "./MAOrders.vue?vue&type=style&index=0&id=45174a6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports